import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "./lib/lang";
import { SmoothScroll, scrollToId } from "./lib/smooth";
import { ConsentBanner } from "./components/ConsentBanner";
import Home from "./pages/Home";
import About from "./pages/About";
import Programmes from "./pages/Programmes";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";
import Legal from "./pages/LegalPages";
import { Header } from "./components/Header";
import { Footer, FloatingButtons } from "./components/SiteFooter";
import Admin from "./pages/Admin";

/* On every page change: jump to the #section if the link has one, otherwise to the top. */
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
      return undefined;
    }
    const t = setTimeout(() => scrollToId(hash.slice(1)), 120);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-sun focus:px-4 focus:py-2 focus:font-bold focus:text-night">Skip to content</a>
        <Header />
        <div id="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programmes" element={<Programmes />} />
            <Route path="/contact" element={<ContactPage />} />
            {["privacy", "terms", "cookies", "disclaimer"].map((p) => <Route key={p} path={`/${p}`} element={<Legal page={p} />} />)}
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
        <FloatingButtons />
        <ConsentBanner />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
